var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 53.243 53.243",
    style: {
      enableBackground: "new 0 0 53.243 53.243"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Instagram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.717,9.507c-1.724,0-3.121,1.398-3.121,3.121c0,1.724,1.398,3.122,3.121,3.122 c1.724,0,3.122-1.398,3.122-3.122C43.839,10.904,42.441,9.507,40.717,9.507z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M26.84,13.509c-7.23,0-13.112,5.882-13.112,13.112 c0,7.23,5.882,13.112,13.112,13.112c7.23,0,13.112-5.882,13.112-13.112C39.952,19.391,34.07,13.509,26.84,13.509z M26.84,35.02 c-4.632,0-8.399-3.768-8.399-8.399c0-4.632,3.768-8.399,8.399-8.399c4.631,0,8.399,3.768,8.399,8.399 C35.239,31.253,31.471,35.02,26.84,35.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M37.249,53.243H15.992C7.174,53.243,0,46.069,0,37.25V15.992 C0,7.174,7.174,0,15.992,0h21.257c8.818,0,15.993,7.174,15.993,15.992V37.25C53.243,46.069,46.068,53.243,37.249,53.243z  M15.992,5.009c-6.057,0-10.984,4.927-10.984,10.983V37.25c0,6.057,4.927,10.984,10.984,10.984h21.257 c6.057,0,10.984-4.927,10.984-10.984V15.992c0-6.057-4.927-10.983-10.984-10.983H15.992z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.3d3ab29929bca05805675ada035a1cda.svg";
export { ForwardRef as ReactComponent };